var $ = require('jquery');

module.exports = {
  init() {
    $(document).ready(() => {
      //
      $(window).off('scroll', this.handleButton);
      $(window).on('scroll', this.handleButton);

      //
      $(window).off('resize', this.handleButtonPosition);
      $(window).on('resize', this.handleButtonPosition);

      //
      $('.buttonUp').off('click', this.handleClick);
      $('.buttonUp').on('click', this.handleClick);
    });
  },
  // Click event to scroll to top
  handleClick() {
    $('html, body').animate({ scrollTop: 0 }, 300);
    return false;
  },
  // Checks if "scroll to top" button should stick to the bottom of the window or to the top of the footer
  handleButtonPosition() {
    if (!$('.buttonUp').is(':visible')) {
      return;
    }

    let footerToTop = $('.footer').offset().top,
      scrollTop = $(document).scrollTop() + window.innerHeight,
      difference = scrollTop - footerToTop;

    if (scrollTop > footerToTop) {
      $('.buttonUp').css('bottom', difference);
      return;
    }

    $('.buttonUp').css('bottom', 0);
  },
  handleButton() {
    if ($(this).scrollTop() > 300) {
      $('.buttonUp').fadeIn();
    } else {
      $('.buttonUp').fadeOut();
    }

    module.exports.handleButtonPosition();
  }
};
